export enum EvaluationModuleType {
  SELF_REFLECTION = 'SELF_REFLECTION',
  PEER_REVIEW = 'PEER_REVIEW',
  MANAGER_REVIEW_EMPLOYEE = 'MANAGER_REVIEW_EMPLOYEE',
}